module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#sports",
      toString: function () {
        return this.url;
      }
    }